// @flow
import React, { Component } from 'react';
import { observer } from 'mobx-react';
import { observable, action } from 'mobx';

import DistanceCircles from "./DistanceCircles"
import UnitView from "./UnitView"
import Board from "../lib/Board"
import DragController from "../lib/DragController"
import CanvasBullets from "./CanvasBullets"
import CanvasShootingLevels from "./CanvasShootingLevels"

@observer
class BoardView extends Component {

    @observable panX: number = 0
    @observable panY: number = 0
    // Controls the moving/panning of the board
    dragController: DragController

    constructor(props) {
        super(props)
        this.dragController = new DragController(this)
    }

    props: {
        board: Board,
        boardClick: mixed,
        clickOnUnit: mixed,
        changeZoom: mixed, 
        zoomFactor: number
    }

    mouseDown = (e) => {
        this.dragController.start(e, this.refs.board)
        e.stopPropagation();
        e.preventDefault();
    }

    @action
    mouseMove = (e) => {
        this.dragController.move(e)
        e.stopPropagation();
        e.preventDefault();
    }

    mouseUp = (e) => {
        if(this.refs.board === e.target && 
                this.dragController.mouseDown && 
                !this.dragController.mousePanning) {
            const pageX = e.pageX || e.changedTouches.item(0).pageX
            const pageY = e.pageY || e.changedTouches.item(0).pageY
            const { board: { width, screenWidth, height, screenHeight }} = this.props
            const translateX =  -(width - screenWidth) / 2
            const translateY = -(height - screenHeight) / 2
            this.props.boardClick(pageX-translateX-this.panX,  pageY-translateY-this.panY)
            e.preventDefault();
            e.stopPropagation();
        }
        this.dragController.release()
    }

    mouseWheel = (e) => {
        if(this.refs.board === e.target) {
            this.props.changeZoom(e.deltaY)
        }
    }

    render() {
        const { zoomFactor, clickOnUnit, board: { width, height, screenWidth, screenHeight, units, bullets } } = this.props
        const translateX =  -(width - screenWidth) / 2
        const translateY = -(height - screenHeight) / 2
        return (
            [
            <div 
                ref="board" 
                className="board" 
                onWheel={this.mouseWheel} 
                onTouchStart={this.mouseDown} 
                onTouchMove={this.mouseMove}
                onTouchEnd={this.mouseUp} 
                onMouseDown={this.mouseDown} 
                onMouseMove={this.mouseMove}
                onMouseUp={this.mouseUp} 
                style={{ 
                    width: width, height: height ,
                    transform: "scale("+zoomFactor+")" ,
                    left: translateX + this.panX, 
                    top: translateY + this.panY
                }}>

                <CanvasBullets width={width} height={height} units={units} bullets={bullets} />
                <CanvasShootingLevels width={width} height={height} units={units} />
                {units.map(unit => <DistanceCircles key={unit.id} unit={unit} />)}
                {units.map(unit => <UnitView key={unit.id} unit={unit} clickOnUnit={clickOnUnit} />)}
            </div>
            ]
        )
    }
}


export default BoardView



// WEBPACK FOOTER //
// ./src/components/BoardView.js